import React, { Component } from 'react';
import classNames from 'classnames';
import "./filter.css";
import Light from "../light/light-component";



class Filter extends Component {


  state = {
    tooltipIsShown: false
  };


  showTooltip = () => this.setState({ tooltipIsShown: true });
  hideTooltip = () => this.setState({ tooltipIsShown: false });


  render() {
    const {
      filters,
      filterName,
      toggle,
      containerIndex,
      deleteFilter,
      isScore,
      toggleIsScore
    } = this.props;
    return (
      <div className="filter_container">
        <div className="filter_container__name_container">
          <div className="filter_container__name_container__item" style={{width: '80%'}} >
            <span className="filter_container__name_container__name">{filterName}</span>
          </div>
          <div className="filter_container__name_container__item" style={{
            width: '10%',
            cursor: 'pointer'
          }}
               onClick={toggleIsScore}
          >
            <Light
              className="filter_container__name_container__delete"
              isGreen={isScore}
              showTooltip={this.showTooltip}
              hideTooltip={this.hideTooltip}
              tooltipIsShown={this.state.tooltipIsShown}
              tooltipText="Set this filter as score"
            />
          </div>
          <div className="filter_container__name_container__item" style={{width: '10%'}}>
            <i
              onClick={() => deleteFilter(containerIndex)}
              className="far fa-trash-alt filter_container__name_container__delete"
            />
          </div>
        </div>
        <div className="filter_container__filters">
          {
            filters.map((filter, filterIndex) => {
              const all = filter.value === 'All';
              return (
                <div key={filterIndex}
                     className={classNames({
                       "filter_container__filters__filter": true,
                       "filter_selected": filter.selected
                     })}
                     onClick={() => toggle({ filterIndex, containerIndex, all })}
                >
                  <span className="filter_container__filters__filter__value" >{ !all ? filter.value : 'All' }</span>
                  {!all && <span className="filter_container__filters__filter__count">{filter.count}</span>}
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
}


export default Filter;


// WEBPACK FOOTER //
// ./src/components/filter/filter-component.js